export default __webpack_public_path__ + "static/media/Package.147f45ec.svg";